module.exports = __webpack_public_path__ + "img/google-play-badge.e3ea015c.svg";